

import { createWallet, walletConnect, inAppWallet } from "thirdweb/wallets";
import { createThirdwebClient } from "thirdweb";
import { ConnectButton, darkTheme } from "thirdweb/react";
import { defineChain } from "thirdweb/chains";
import { ethers, JsonRpcProvider } from "ethers";
import { getContract } from "thirdweb";
import CYBERNAUT from "../abi/CYBERNAUTS.json";
import Legend from "../abi/Legend.json";
import JESSE from "../abi/JESSE.json";
import { ethers6Adapter } from "thirdweb/adapters/ethers6";
import Pyth from '@pythnetwork/pyth-sdk-solidity/abis/IPyth.json';
import { Address, Avatar, Name, Identity, EthBalance } from '@coinbase/onchainkit/identity';
import { ConnectWallet, WalletDropdown, WalletDropdownBasename, WalletDropdownDisconnect, Wallet } from '@coinbase/onchainkit/wallet';

//onchainKit

export function CoinbaseConnector() {
  return (
    <div className="flex justify-end">
      <Wallet>
        <ConnectWallet>
          <Avatar className="h-6 w-6" />
          <Name />
        </ConnectWallet>
        <WalletDropdown>
          <Identity className="px-4 pt-3 pb-2" hasCopyAddressOnClick>
            <Avatar />
            <Name />
            <Address />
            <EthBalance />
          </Identity>
          <WalletDropdownBasename />
          <WalletDropdownDisconnect />
        </WalletDropdown>
      </Wallet>
    </div>
  );
}

//Thirdweb wallet connect
// Global Constants ***************************************************************************************************************
export const client = createThirdwebClient({
  clientId: 'b3c902ed5c43951a631c4f66d665d12b',
});

export const wallets = [
  // createWallet("com.coinbase.wallet"),
  // walletConnect(),
  // createWallet("io.metamask"),
  // inAppWallet({
  //   auth: {
  //     // mode: "redirect",
  //     options: [
  //       "farcaster",
  //       "google",
  //       "x",
  //       "telegram",
  //       "facebook",
  //       "discord",
  //       "apple",
  //       "phone",
  //       "email",
  //     ],
  //   },
  // }),
];

export const blockchain = {
  // mainnet
  name: 'Jesse',
  symbol: 'JESSE',
  // partner1: 'Moth',
  // partner1_symbol: 'MOTH',
  address: '0x683046277b72c02B3Ac266761B02d3eaA0C25c9a',
  chainId: 8453,
  rpc: 'https://gateway.tenderly.co/public/base', // 'https://base-mainnet.infura.io/v3/ae878c0a9cd644f7a48f2cc265f61cf3', // 'https://base.public.blockpi.network/v1/rpc/public',
  blockExplorer: 'https://basescan.org',
  jesse_contract_address: "0x50F88fe97f72CD3E75b9Eb4f747F59BcEBA80d59",
  decimals: 18,
  pyth_contract_address: "0x8250f4aF4B972684F7b336503E2D6dFeDeB1487a",
  legend_contract_address: "0x5AD10b04Ac3F02471D41ae5143e35eE5493F10df",
  // partner1_contract_address: "0xB87BE8c350d600290D9EcCBAA8cA73cf969a41A4", 
  base_price_id: "0xff61491a931112ddf1bd8147cd1b641375f79f5825126d665480874634fd0ace", // Base/USD 

  // testnet
  // name: 'Jesse',
  // symbol: 'JESSE',
  // // partner1: 'Moth',
  // // partner1_symbol: 'MOTH',
  // address: '0x683046277b72c02B3Ac266761B02d3eaA0C25c9a',
  // chainId: 8453,
  // rpc: 'https://developer-access-mainnet.base.org',
  // blockExplorer: 'https://basescan.org',
  // jesse_contract_address: "0x50F88fe97f72CD3E75b9Eb4f747F59BcEBA80d59",
  // decimals: 18,
  // pyth_contract_address: "0x2880ab155794e7179c9ee2e38200202908c17b43",
  // legend_contract_address: "0xE153921AF05bB17bA83c236a9C43d8d268716342",
  // // partner1_contract_address: "0xB87BE8c350d600290D9EcCBAA8cA73cf969a41A4", 
  // base_price_id: "0xf490b178d0c85683b7a0f2388b40af2e6f7c90cbe0f96b31f315f08d0e5a2d6d", // Base/USD
};

export const base = defineChain({ id: blockchain.chainId, rpc: blockchain.rpc});
export const provider = new JsonRpcProvider(blockchain.rpc);

// convert a thirdweb account to ethers signer
export const getSigner = async (account) => {    
  try {   
    //signers & providers
    const ethersSigner = ethers6Adapter.signer.toEthers({
      client,
      chain: base,
      account: account,
    });
    
    return ethersSigner;
  } catch (error) {
      console.error('Error getting signer:', error);
  }
};

//ABIs
export const abi = {legend: Legend.abi, cybernaut: CYBERNAUT.abi, jesse: JESSE.abi, pyth: Pyth};

//ethers contracts
export const contract = new ethers.Contract(blockchain.address, abi.cybernaut, provider);
export const legendaryContract = new ethers.Contract(blockchain.legend_contract_address, abi.legend, provider);
export const jesseContract = new ethers.Contract(blockchain.jesse_contract_address, abi.jesse, provider);

//oracle contracts 
export const oracleProvider = ethers.getDefaultProvider(blockchain.rpc);
export const oraclePriceContract = new ethers.Contract(blockchain.pyth_contract_address, abi.pyth, oracleProvider);


//getContracts Thirdweb
  // Mint contract
export const thirdwebContract = getContract({
  // the client you have created via `createThirdwebClient()`
  client,
  // the chain the contract is deployed on
  chain: base,
  // the contract's address
  address: blockchain.address,
  // OPTIONAL: the contract's abi
  abi: abi.cybernaut,
});

//JESSE contract
export const thirdwebJESSEContract = getContract({
  // the client you have created via `createThirdwebClient()`
  client,
  // the chain the contract is deployed on
  chain: base,
  // the contract's address
  address: blockchain.jesse_contract_address,
  // OPTIONAL: the contract's abi
  abi: abi.jesse,
});

//Thirdweb price oracle
export const thirdwebLegendaryContract = getContract({
  // the client you have created via `createThirdwebClient()`
  client,
  // the chain the contract is deployed on
  chain: base,
  // the contract's address
  address: blockchain.legend_contract_address,
  // OPTIONAL: the contract's abi
  abi: abi.legend,
});

export function Connector () {
  return (
    <ConnectButton
      client={client}
      chain={base}
      wallets={wallets}
      theme={darkTheme({
        colors: {
          primaryText: "#7FFF00",
          secondaryText: "#FFF8DC",
          connectedButtonBg: "#252525",
          connectedButtonBgHover: "#161616",
          separatorLine: "#262830",
          primaryButtonBg: "#7FFF00",
        },
      })}
        supportedTokens={{
          [blockchain.chainId]: [{
            address: blockchain.jesse_contract_address,
            name: blockchain.name,
            symbol: blockchain.symbol,
            icon: 'https://cybernauts.fun/assets/images/jesse_logo.png',
          },
          // {
          //   address: blockchain.partner1_contract_address,
          //   name: blockchain.partner1,
          //   symbol: blockchain.partner1_symbol,
          //   icon: 'https://cybernauts.fun/assets/images/partner1_logo.jpg',
          // }
        ]
        }}
        connectButton={{ label: "Login" }}
        connectModal={{
          size: "wide",
          title: "Socials or Wallet",
          titleIcon:
            "https://cybernauts.fun/assets/images/logo512.webp",
          welcomeScreen: {
            title: "Jesse and the Cybernauts!",
            subtitle:
              "...unleashing kickass GambleFi and Yield on Base.",
            img: {
              src: 'https://cybernauts.fun/assets/images/logo512.webp',
              width: 250,
              height: 250,
            },
          },
        }}
      />     
  );
}

// Shuffle implementation
export const randomShuffle = (max) => {
  return Math.floor(Math.random() * max);
};

// Fisher-Yates shuffle implementation
export function fisherYatesShuffle(array) {
  for (let i = array.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1)); // Random index from 0 to i
      [array[i], array[j]] = [array[j], array[i]]; // Swap elements
  }
  return array;
}

export const copyClipboard = async(text) => {
  await navigator.clipboard.writeText(text);
}
  
//export esthetics
export const truncateAddress = (address) => {
  if (!address) return "No Account";
  const match = address.match(
    /^(0x[a-zA-Z0-9]{4})[a-zA-Z0-9]+([a-zA-Z0-9]{4})$/
  );
  if (!match) return address;
  return `${match[1]} ... ${match[2]}`;
};

export const formatNumber = (number) => {
  if (!number) return "0";
  const formatter = new Intl.NumberFormat("en-US", {
    minimumFractionDigits: 0,
    maximumFractionDigits: 3,
  });
  return formatter.format(number);
};

export const removeThousands = (value) => {
  const cleanedValue = value.replace(/,/g, '');
  const integerPart = cleanedValue.split('.')[0];
  return integerPart;
};

export function normalizeNumberString(n) {
  // convert scientific to decimal string manually
  return Number(n).toLocaleString('en-US', {
    minimumFractionDigits: 18,
    useGrouping: false
  });
}
    
// export const latin = [
//   'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Si longus, levis; Sed quid sentiat, non videtis. Non autem hoc: igitur ne illud quidem. Aliter enim explicari, quod quaeritur, non potest. An nisi populari fama',
//   'Quae quidem sapientes sequuntur duce natura tamquam videntes; Duo Reges: constructio interrete. Certe non potest. An vero, inquit, quisquam potest probare, quod perceptfum, quod. Beatus sibi videtur esse moriens.',
//   'Eiuro, inquit adridens, iniquum, hac quidem de re; Haec igitur Epicuri non probo, inquam. Quis istud possit, inquit, negare? Quod ea non occurrentia fingunt, vincunt Aristonem;',
//   'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Habes, inquam, Cato, formam eorum, de quibus loquor, philosophorum. Minime vero, inquit ille, consentit. Si stante, hoc natura videlicet vult, salvam esse se, quod concedimus; Huius, Lyco, oratione locuples, rebus ipsis ielunior. Virtutis, magnitudinis animi, patientiae, fortitudinis fomentis dolor mitigari solet. An hoc usque quaque, aliter in vita? Duo Reges: constructio interrete. Quid dubitas igitur mutare principia naturae?',
//   'Quis non odit sordidos, vanos, leves, futtiles? Sed ille, ut dixi, vitiose. Unum nescio, quo modo possit, si luxuriosus sit, finitas cupiditates habere. Bork Quam ob rem tandem, inquit, non satisfacit? At Zeno eum non beatum modo, sed etiam divitem dicere ausus est. Quid ait Aristoteles reliquique Platonis alumni? Tum ille: Ain tandem? Vitiosum est enim in dividendo partem in genere numerare.',
//   'Item de contrariis, a quibus ad genera formasque generum venerunt. Sin dicit obscurari quaedam nec apparere, quia valde parva sint, nos quoque concedimus; Verum audiamus. Sequitur disserendi ratio cognitioque naturae; Perturbationes autem nulla naturae vi commoventur, omniaque ea sunt opiniones ac iudicia levitatis. Nihil acciderat ei, quod nollet, nisi quod anulum, quo delectabatur, in mari abiecerat. Restinguet citius, si ardentem acceperit. Ex ea difficultate illae fallaciloquae, ut ait Accius, malitiae natae sunt. Reguli reiciendam;',
//   'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Deinceps videndum est, quoniam satis apertum est sibi quemque natura esse carum, quae sit hominis natura. Quod est, ut dixi, habere ea, quae secundum naturam sint, vel omnia vel plurima et maxima. Naturales divitias dixit parabiles esse, quod parvo esset natura contenta. Duo Reges: constructio interrete. Itaque a sapientia praecipitur se ipsam, si usus sit, sapiens ut relinquat. Vives, inquit Aristo, magnifice atque praeclare, quod erit cumque visum ages, numquam angere, numquam cupies, numquam timebis. Scaevola tribunus plebis ferret ad plebem vellentne de ea re quaeri. Coniunctio autem cum honestate vel voluptatis vel non dolendi id ipsum honestum, quod amplecti vult, id efficit turpe.',
//   'Beatus autem esse in maximarum rerum timore nemo potest. Partim cursu et peragratione laetantur, congregatione aliae coetum quodam modo civitatis imitantur; Aliter enim nosmet ipsos nosse non possumus. Suo genere perveniant ad extremum; Num igitur utiliorem tibi hunc Triarium putas esse posse, quam si tua sint Puteolis granaria? Nam illud vehementer repugnat, eundem beatum esse et multis malis oppressum.',
//   'Mihi enim satis est, ipsis non satis. Paulum, cum regem Persem captum adduceret, eodem flumine invectio? Negabat igitur ullam esse artem, quae ipsa a se proficisceretur; Estne, quaeso, inquam, sitienti in bibendo voluptas? Eam si varietatem diceres, intellegerem, ut etiam non dicente te intellego; Facit enim ille duo seiuncta ultima bonorum, quae ut essent vera, coniungi debuerunt; Quid ei reliquisti, nisi te, quoquo modo loqueretur, intellegere, quid diceret? Quid, cum volumus nomina eorum, qui quid gesserint, nota nobis esse, parentes, patriam, multa praeterea minime necessaria? Cum sciret confestim esse moriendum eamque mortem ardentiore studio peteret, quam Epicurus voluptatem petendam putat. Sin autem eos non probabat, quid attinuit cum iis, quibuscum re concinebat, verbis discrepare? Manebit ergo amicitia tam diu, quam diu sequetur utilitas, et, si utilitas amicitiam constituet, tollet eadem. Est igitur officium eius generis, quod nec in bonis ponatur nec in contrariis.'
// ]
    